<template>
  <validation-observer ref="simpleRules">
    <user-type-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>
<script>
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import UserTypeForm from '@/views/Admin/User_types/UserTypeForm.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import toastMixin from '@/libs/toast'

export default {
  name: 'Edit',
  components: {
    UserTypeForm,
    SaveButton,
    ValidationObserver,
  },
  mixins: [toastMixin],
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['userTypes/dataItem']
    },
    saveData() {
      return this.$store.getters['userTypes/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'saveSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'saveError' })
      }
    },
  },
  created() {
    this.getData()
    localize('tr')
  },
  methods: {
    getData() {
      this.$store.dispatch('userTypes/getDataItem', this.$route.params.id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('userTypes/saveData', this.dataItem)
        } else {
          this.showToast({ template: 'requireWarning' })
        }
      })
    },
  },
}
</script>
